import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Paper, TextField, Alert, CircularProgress } from '@mui/material';
import authService from 'services/authService'; 

const UserProfile = () => {
  const [profile, setProfile] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingPassword, setIsEditingPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
  });
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    newPasswordConfirmation: '',
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(true); // Estado para controlar o loading

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const userProfile = await authService.getProfile();
        if (userProfile) {
          setProfile(userProfile);
          setFormData({
            name: userProfile.nome,  
            email: userProfile.email, 
          });
        }
      } catch (error) {
        console.error('Erro ao buscar perfil do usuário:', error);
      } finally {
        setLoading(false); // Desativa o loading após buscar os dados
      }
    };
    fetchProfile();
  }, []);

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handlePasswordToggle = () => {
    setIsEditingPassword(!isEditingPassword);
    setErrorMessage('');  // Limpa mensagem de erro
    setSuccessMessage('');  // Limpa mensagem de sucesso
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handlePasswordChange = (e) => {
    setPasswordData({
      ...passwordData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = async () => {
    await authService.updateProfile(formData);
    setIsEditing(false);
    setProfile({
      ...profile,
      name: formData.name,
      email: formData.email,
    });
  };

  const handlePasswordSave = async () => {
    try {
      await authService.updatePassword({
        current_password: passwordData.currentPassword,
        new_password: passwordData.newPassword,
        new_password_confirmation: passwordData.newPasswordConfirmation,
      });
      setSuccessMessage('Senha atualizada com sucesso');
      setIsEditingPassword(false);
      setPasswordData({
        currentPassword: '',
        newPassword: '',
        newPasswordConfirmation: '',
      });
    } catch (error) {
      setErrorMessage('Erro ao atualizar a senha');
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <CircularProgress />
      </Box>
    );
  }

  // if (!profile) {
  //   return <Typography>Carregando...</Typography>;
  // }

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" gutterBottom>
        Perfil do Usuário
      </Typography>
      <Paper sx={{ padding: 2, maxWidth: 600 }}>
        {isEditing ? (
          <>
            <TextField
              label="Nome"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="E-mail"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
            />
            <Button variant="contained" color="primary" onClick={handleSave} sx={{ mt: 2 }}>
              Salvar
            </Button>
          </>
        ) : (
          <>
            <Typography variant="h6">Nome: {profile.nome}</Typography>
            <Typography variant="h6">E-mail: {profile.email}</Typography>
            <Button variant="outlined" color="primary" onClick={handleEditToggle} sx={{ mt: 2 }}>
              Editar Perfil
            </Button>
          </>
        )}
      </Paper>

      <Paper sx={{ padding: 2, maxWidth: 600, mt: 4 }}>
        <Typography variant="h6">Alterar Senha</Typography>
        {isEditingPassword ? (
          <>
            {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
            {successMessage && <Alert severity="success">{successMessage}</Alert>}
            <TextField
              label="Senha Atual"
              name="currentPassword"
              type="password"
              value={passwordData.currentPassword}
              onChange={handlePasswordChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Nova Senha"
              name="newPassword"
              type="password"
              value={passwordData.newPassword}
              onChange={handlePasswordChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Confirmar Nova Senha"
              name="newPasswordConfirmation"
              type="password"
              value={passwordData.newPasswordConfirmation}
              onChange={handlePasswordChange}
              fullWidth
              margin="normal"
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handlePasswordSave}
              sx={{ mt: 2 }}
              disabled={
                !passwordData.currentPassword ||
                !passwordData.newPassword ||
                !passwordData.newPasswordConfirmation
              }
            >
              Atualizar Senha
            </Button>
          </>
        ) : (
          <Button variant="outlined" color="primary" onClick={handlePasswordToggle} sx={{ mt: 2 }}>
            Alterar Senha
          </Button>
        )}
      </Paper>
    </Box>
  );
};

export default UserProfile;